import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "debugging---advanced-debugging-for-nodejs-actions"
    }}>{`Debugging - Advanced Debugging for Node.js Actions`}</h1>
    <p>{`The easiest way to debug your actions is using a local Node.js server and run the action code on your machine. However, this is not exactly the environment used by I/O Runtime to execute your actions. This is where `}<inlineCode parentName="p">{`wskdebug`}</inlineCode>{` steps in and helps you to debug and do live development. It's even integrated with Visual Studio Code.`}</p>
    <p>{`This is how it works: your action deployed on I/O Runtime is replaced with a special agent that will send the activation to the local container and take the local container activation result back to the original activation. The action is actually executed on your local container. This local environment has the debug port open so you can connect and IDE to it.`}</p>
    <p>{`Be aware that in the unlikely event that the agent is killed by I/O Runtime while running, you'll need to restore the original action content.`}</p>
    <h2 {...{
      "id": "installing-wskdebug"
    }}>{`Installing `}<inlineCode parentName="h2">{`wskdebug`}</inlineCode></h2>
    <p>{`You'll need Node.js, version 10 or newer, and a local `}<a parentName="p" {...{
        "href": "https://www.docker.com/products/docker-desktop"
      }}>{`Docker environment`}</a>{`. You can grab `}<inlineCode parentName="p">{`wskdebug`}</inlineCode>{` from this `}<a parentName="p" {...{
        "href": "https://github.com/adobe/wskdebug"
      }}>{`GitHub repo`}</a>{` or use npm to install it:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm install -g @adobe/wskdebug
`}</code></pre>
    <p>{`Next, assuming that you have Docker configured locally, you need to run the wskdebug in Terminal in order to pull on your machine the latest image used by I/O Runtime to execute Node.js actions:`}</p>
    <pre><code parentName="pre" {...{}}>{` wskdebug --inspect-brk=11932 <ACTION NAME> <FULL PATH TO THE SOURCE FILE> -l 
`}</code></pre>
    <h2 {...{
      "id": "visual-studio-code-example"
    }}>{`Visual Studio Code Example`}</h2>
    <p>{`Before you can debug your action code, open the source file for your action and create the `}<a parentName="p" {...{
        "href": "https://code.visualstudio.com/docs/editor/debugging#_launch-configurations"
      }}>{`launch.json`}</a>{` with this content:`}</p>
    <pre><code parentName="pre" {...{}}>{`"configurations": [
        {
            "type": "node",
            "request": "launch",
            "name": "wskdebug <ACTION NAME>",
            "runtimeExecutable": "wskdebug",
            "args": [ "<ACTION NAME>", "\${workspaceFolder}/<ACTION SOURCE FILE>", "-l" ],
            "localRoot": "\${workspaceFolder}",
            "remoteRoot": "/code",
            "outputCapture": "std"
        }
    ]
`}</code></pre>
    <p>{`Next, go back to your action code and place breakpoints and then launch the debugger. Once the debugger was launched (keep an eye on the Debug Console window), you just need to invoke the action. Once invoked, the first breakpoint will be hit and you can inspect the variables step over/next. You can even change the code and once is saved, it is automatically re-executed.`}</p>
    <p>{`For more details about how `}<inlineCode parentName="p">{`wskdebug`}</inlineCode>{` works, its limitations and how you can use it to its full potential, please read the `}<a parentName="p" {...{
        "href": "https://github.com/adobe/wskdebug"
      }}>{`official docs`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      